module.exports = __webpack_public_path__ + "static/media/family.2f259f4d.jpg";